import {
  PublicClientApplication,
  BrowserCacheLocation,
} from '@azure/msal-browser';
import { MSAL_INSTANCE } from '@azure/msal-angular';
import { environment } from '@env/environment';

export function msalInstanceFactory(): PublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: environment.azureClientIdSpa,
      authority: `https://login.microsoftonline.com/${environment.azureTenantId}`,
      redirectUri: environment.azureRedirectUri,
      postLogoutRedirectUri: environment.azureRedirectUri,
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
      storeAuthStateInCookie: false,
    },
  });
}

export const MSAL_PROVIDERS = [
  {
    provide: MSAL_INSTANCE,
    useFactory: msalInstanceFactory,
  },
];
